/** Valores em reais inteiros, arredondados para baixo. */
export type EligibleReferralInvite = {
  eligible: true;
  referralCode: string;
  referralRate: number;
  /** `YYYY-MM`. */
  revenueMonth: string;
  lastMonthRevenue: number;
  monthlyProjection: number;
  threeReferralsProjection: number;
};

export type ReferralInvite = EligibleReferralInvite | { eligible: false };

export enum ReferralInviteEvent {
  SHOWN = 'SHOWN',
  DISMISSED = 'DISMISSED',
  LINK_COPIED = 'LINK_COPIED',
  LINK_SHARED = 'LINK_SHARED',
}
